import Page00 from '../../../../Book/EbookEtape_4/pages/00';
import Page01 from '../../../../Book/EbookEtape_4/pages/01';
import Page02 from '../../../../Book/EbookEtape_4/pages/02';
import Page03 from '../../../../Book/EbookEtape_4/pages/03';
import Page04 from '../../../../Book/EbookEtape_4/pages/04';
import Page05 from '../../../../Book/EbookEtape_4/pages/05';
import Page06 from '../../../../Book/EbookEtape_4/pages/06';
import Page07 from '../../../../Book/EbookEtape_4/pages/07';
import Page08 from '../../../../Book/EbookEtape_4/pages/08';
import Page09 from '../../../../Book/EbookEtape_4/pages/09';
import Page10 from '../../../../Book/EbookEtape_4/pages/10';
import Page11 from '../../../../Book/EbookEtape_4/pages/11';
import Page12 from '../../../../Book/EbookEtape_4/pages/12';
import Page13 from '../../../../Book/EbookEtape_4/pages/13';
import Page14 from '../../../../Book/EbookEtape_4/pages/14';
import Page15 from '../../../../Book/EbookEtape_4/pages/15';
import Page16 from '../../../../Book/EbookEtape_4/pages/16';
import Page17 from '../../../../Book/EbookEtape_4/pages/17';
import Page18 from '../../../../Book/EbookEtape_4/pages/18';
import Page19 from '../../../../Book/EbookEtape_4/pages/19';
import Page20 from '../../../../Book/EbookEtape_4/pages/20';
import Page21 from '../../../../Book/EbookEtape_4/pages/21';
import Page22 from '../../../../Book/EbookEtape_4/pages/22';
import Page23 from '../../../../Book/EbookEtape_4/pages/23';
import Page24 from '../../../../Book/EbookEtape_4/pages/24';
import Page25 from '../../../../Book/EbookEtape_4/pages/25';
import Page26 from '../../../../Book/EbookEtape_4/pages/26';
import Page27 from '../../../../Book/EbookEtape_4/pages/27';
import Page28 from '../../../../Book/EbookEtape_4/pages/28';
import Page29 from '../../../../Book/EbookEtape_4/pages/29';
import Page30 from '../../../../Book/EbookEtape_4/pages/30';
import Page31 from '../../../../Book/EbookEtape_4/pages/31';
import Page32 from '../../../../Book/EbookEtape_4/pages/32';
import Page33 from '../../../../Book/EbookEtape_4/pages/33';
import Page34 from '../../../../Book/EbookEtape_4/pages/34';
import Page35 from '../../../../Book/EbookEtape_4/pages/35';
import Page36 from '../../../../Book/EbookEtape_4/pages/36';
import Page37 from '../../../../Book/EbookEtape_4/pages/37';
import Page38 from '../../../../Book/EbookEtape_4/pages/38';
import Page39 from '../../../../Book/EbookEtape_4/pages/39';
import Page40 from '../../../../Book/EbookEtape_4/pages/40';
import Page41 from '../../../../Book/EbookEtape_4/pages/41';
import Page42 from '../../../../Book/EbookEtape_4/pages/42';
import Page43 from '../../../../Book/EbookEtape_4/pages/43';
import Page44 from '../../../../Book/EbookEtape_4/pages/44';
import Page45 from '../../../../Book/EbookEtape_4/pages/45';

type StepContentProps = {
  readOnly: boolean;
};

const Step4Content = ({ readOnly }: StepContentProps) => (
  <>
    <Page00 />
    <Page01 />
    <Page02 />
    <Page03 />
    <Page04 readOnly={readOnly} />
    <Page05 />
    <Page06 />
    <Page07 />
    <Page08 />
    <Page09 />
    <Page10 />
    <Page11 />
    <Page12 />
    <Page13 />
    <Page14 />
    <Page15 />
    <Page16 />
    <Page17 />
    <Page18 readOnly={readOnly} />
    <Page19 readOnly={readOnly} />
    <Page20 />
    <Page21 />
    <Page22 readOnly={readOnly} />
    <Page23 />
    <Page24 />
    <Page25 />
    <Page26 readOnly={readOnly} />
    <Page27 />
    <Page28 />
    <Page29 readOnly={readOnly} />
    <Page30 />
    <Page31 />
    <Page32 />
    <Page33 />
    <Page34 readOnly={readOnly} />
    <Page35 readOnly={readOnly} />
    <Page36 />
    <Page37 />
    <Page38 readOnly={readOnly} />
    <Page39 readOnly={readOnly} />
    <Page40 readOnly={readOnly} />
    <Page41 readOnly={readOnly} />
    <Page42 />
    <Page43 />
    <Page44 />
    <Page45 readOnly={readOnly} />
  </>
);

export default Step4Content;
